@theme {
  --color-ember-50: var(--ember-50);
  --color-ember-100: var(--ember-100);
  --color-ember-150: var(--ember-150);
  --color-ember-200: var(--ember-200);
  --color-ember-250: var(--ember-250);
  --color-ember-300: var(--ember-300);
  --color-ember-350: var(--ember-350);
  --color-ember-400: var(--ember-400);
  --color-ember-450: var(--ember-450);
  --color-ember-500: var(--ember-500);
  --color-ember-550: var(--ember-550);
  --color-ember-600: var(--ember-600);
  --color-ember-650: var(--ember-650);
  --color-ember-700: var(--ember-700);
  --color-ember-750: var(--ember-750);
  --color-ember-800: var(--ember-800);
  --color-ember-850: var(--ember-850);
  --color-ember-900: var(--ember-900);
  --color-ember-950: var(--ember-950);
  --color-ember-1000: var(--ember-1000);
  --color-ember-1050: var(--ember-1050);
  --color-earthfire-50: var(--earthfire-50);
  --color-earthfire-100: var(--earthfire-100);
  --color-earthfire-150: var(--earthfire-150);
  --color-earthfire-200: var(--earthfire-200);
  --color-earthfire-250: var(--earthfire-250);
  --color-earthfire-300: var(--earthfire-300);
  --color-earthfire-350: var(--earthfire-350);
  --color-earthfire-400: var(--earthfire-400);
  --color-earthfire-450: var(--earthfire-450);
  --color-earthfire-500: var(--earthfire-500);
  --color-earthfire-550: var(--earthfire-550);
  --color-earthfire-600: var(--earthfire-600);
  --color-earthfire-650: var(--earthfire-650);
  --color-earthfire-700: var(--earthfire-700);
  --color-earthfire-750: var(--earthfire-750);
  --color-earthfire-800: var(--earthfire-800);
  --color-earthfire-850: var(--earthfire-850);
  --color-earthfire-900: var(--earthfire-900);
  --color-earthfire-950: var(--earthfire-950);
  --color-earthfire-1000: var(--earthfire-1000);
  --color-earthfire-1050: var(--earthfire-1050);
  --color-fuchsia-heat-50: var(--fuchsia-heat-50);
  --color-fuchsia-heat-100: var(--fuchsia-heat-100);
  --color-fuchsia-heat-150: var(--fuchsia-heat-150);
  --color-fuchsia-heat-200: var(--fuchsia-heat-200);
  --color-fuchsia-heat-250: var(--fuchsia-heat-250);
  --color-fuchsia-heat-300: var(--fuchsia-heat-300);
  --color-fuchsia-heat-350: var(--fuchsia-heat-350);
  --color-fuchsia-heat-400: var(--fuchsia-heat-400);
  --color-fuchsia-heat-450: var(--fuchsia-heat-450);
  --color-fuchsia-heat-500: var(--fuchsia-heat-500);
  --color-fuchsia-heat-550: var(--fuchsia-heat-550);
  --color-fuchsia-heat-600: var(--fuchsia-heat-600);
  --color-fuchsia-heat-650: var(--fuchsia-heat-650);
  --color-fuchsia-heat-700: var(--fuchsia-heat-700);
  --color-fuchsia-heat-750: var(--fuchsia-heat-750);
  --color-fuchsia-heat-800: var(--fuchsia-heat-800);
  --color-fuchsia-heat-850: var(--fuchsia-heat-850);
  --color-fuchsia-heat-900: var(--fuchsia-heat-900);
  --color-fuchsia-heat-950: var(--fuchsia-heat-950);
  --color-fuchsia-heat-1000: var(--fuchsia-heat-1000);
  --color-fuchsia-heat-1050: var(--fuchsia-heat-1050);
  --color-polar-glow-50: var(--polar-glow-50);
  --color-polar-glow-100: var(--polar-glow-100);
  --color-polar-glow-150: var(--polar-glow-150);
  --color-polar-glow-200: var(--polar-glow-200);
  --color-polar-glow-250: var(--polar-glow-250);
  --color-polar-glow-300: var(--polar-glow-300);
  --color-polar-glow-350: var(--polar-glow-350);
  --color-polar-glow-400: var(--polar-glow-400);
  --color-polar-glow-450: var(--polar-glow-450);
  --color-polar-glow-500: var(--polar-glow-500);
  --color-polar-glow-550: var(--polar-glow-550);
  --color-polar-glow-600: var(--polar-glow-600);
  --color-polar-glow-650: var(--polar-glow-650);
  --color-polar-glow-700: var(--polar-glow-700);
  --color-polar-glow-750: var(--polar-glow-750);
  --color-polar-glow-800: var(--polar-glow-800);
  --color-polar-glow-850: var(--polar-glow-850);
  --color-polar-glow-900: var(--polar-glow-900);
  --color-polar-glow-950: var(--polar-glow-950);
  --color-polar-glow-1000: var(--polar-glow-1000);
  --color-polar-glow-1050: var(--polar-glow-1050);
  --color-glacier-pool-50: var(--glacier-pool-50);
  --color-glacier-pool-100: var(--glacier-pool-100);
  --color-glacier-pool-150: var(--glacier-pool-150);
  --color-glacier-pool-200: var(--glacier-pool-200);
  --color-glacier-pool-250: var(--glacier-pool-250);
  --color-glacier-pool-300: var(--glacier-pool-300);
  --color-glacier-pool-350: var(--glacier-pool-350);
  --color-glacier-pool-400: var(--glacier-pool-400);
  --color-glacier-pool-450: var(--glacier-pool-450);
  --color-glacier-pool-500: var(--glacier-pool-500);
  --color-glacier-pool-550: var(--glacier-pool-550);
  --color-glacier-pool-600: var(--glacier-pool-600);
  --color-glacier-pool-650: var(--glacier-pool-650);
  --color-glacier-pool-700: var(--glacier-pool-700);
  --color-glacier-pool-750: var(--glacier-pool-750);
  --color-glacier-pool-800: var(--glacier-pool-800);
  --color-glacier-pool-850: var(--glacier-pool-850);
  --color-glacier-pool-900: var(--glacier-pool-900);
  --color-glacier-pool-950: var(--glacier-pool-950);
  --color-glacier-pool-1000: var(--glacier-pool-1000);
  --color-glacier-pool-1050: var(--glacier-pool-1050);
  --color-deep-current-50: var(--deep-current-50);
  --color-deep-current-100: var(--deep-current-100);
  --color-deep-current-150: var(--deep-current-150);
  --color-deep-current-200: var(--deep-current-200);
  --color-deep-current-250: var(--deep-current-250);
  --color-deep-current-300: var(--deep-current-300);
  --color-deep-current-350: var(--deep-current-350);
  --color-deep-current-400: var(--deep-current-400);
  --color-deep-current-450: var(--deep-current-450);
  --color-deep-current-500: var(--deep-current-500);
  --color-deep-current-550: var(--deep-current-550);
  --color-deep-current-600: var(--deep-current-600);
  --color-deep-current-650: var(--deep-current-650);
  --color-deep-current-700: var(--deep-current-700);
  --color-deep-current-750: var(--deep-current-750);
  --color-deep-current-800: var(--deep-current-800);
  --color-deep-current-850: var(--deep-current-850);
  --color-deep-current-900: var(--deep-current-900);
  --color-deep-current-950: var(--deep-current-950);
  --color-deep-current-1000: var(--deep-current-1000);
  --color-deep-current-1050: var(--deep-current-1050);
  --color-blue-red-50: var(--blue-red-50);
  --color-blue-red-100: var(--blue-red-100);
  --color-blue-red-150: var(--blue-red-150);
  --color-blue-red-200: var(--blue-red-200);
  --color-blue-red-250: var(--blue-red-250);
  --color-blue-red-300: var(--blue-red-300);
  --color-blue-red-350: var(--blue-red-350);
  --color-blue-red-400: var(--blue-red-400);
  --color-blue-red-450: var(--blue-red-450);
  --color-blue-red-500: var(--blue-red-500);
  --color-blue-red-550: var(--blue-red-550);
  --color-blue-red-600: var(--blue-red-600);
  --color-blue-red-650: var(--blue-red-650);
  --color-blue-red-700: var(--blue-red-700);
  --color-blue-red-750: var(--blue-red-750);
  --color-blue-red-800: var(--blue-red-800);
  --color-blue-red-850: var(--blue-red-850);
  --color-blue-red-900: var(--blue-red-900);
  --color-blue-red-950: var(--blue-red-950);
  --color-blue-red-1000: var(--blue-red-1000);
  --color-blue-orange-50: var(--blue-orange-50);
  --color-blue-orange-100: var(--blue-orange-100);
  --color-blue-orange-150: var(--blue-orange-150);
  --color-blue-orange-200: var(--blue-orange-200);
  --color-blue-orange-250: var(--blue-orange-250);
  --color-blue-orange-300: var(--blue-orange-300);
  --color-blue-orange-350: var(--blue-orange-350);
  --color-blue-orange-400: var(--blue-orange-400);
  --color-blue-orange-450: var(--blue-orange-450);
  --color-blue-orange-500: var(--blue-orange-500);
  --color-blue-orange-550: var(--blue-orange-550);
  --color-blue-orange-600: var(--blue-orange-600);
  --color-blue-orange-650: var(--blue-orange-650);
  --color-blue-orange-700: var(--blue-orange-700);
  --color-blue-orange-750: var(--blue-orange-750);
  --color-blue-orange-800: var(--blue-orange-800);
  --color-blue-orange-850: var(--blue-orange-850);
  --color-blue-orange-900: var(--blue-orange-900);
  --color-blue-orange-950: var(--blue-orange-950);
  --color-blue-orange-1000: var(--blue-orange-1000);
  --color-purple-yellow-50: var(--purple-yellow-50);
  --color-purple-yellow-100: var(--purple-yellow-100);
  --color-purple-yellow-150: var(--purple-yellow-150);
  --color-purple-yellow-200: var(--purple-yellow-200);
  --color-purple-yellow-250: var(--purple-yellow-250);
  --color-purple-yellow-300: var(--purple-yellow-300);
  --color-purple-yellow-350: var(--purple-yellow-350);
  --color-purple-yellow-400: var(--purple-yellow-400);
  --color-purple-yellow-450: var(--purple-yellow-450);
  --color-purple-yellow-500: var(--purple-yellow-500);
  --color-purple-yellow-550: var(--purple-yellow-550);
  --color-purple-yellow-600: var(--purple-yellow-600);
  --color-purple-yellow-650: var(--purple-yellow-650);
  --color-purple-yellow-700: var(--purple-yellow-700);
  --color-purple-yellow-750: var(--purple-yellow-750);
  --color-purple-yellow-800: var(--purple-yellow-800);
  --color-purple-yellow-850: var(--purple-yellow-850);
  --color-purple-yellow-900: var(--purple-yellow-900);
  --color-purple-yellow-950: var(--purple-yellow-950);
  --color-purple-yellow-1000: var(--purple-yellow-1000);
  --color-fuchsia-teal-50: var(--fuchsia-teal-50);
  --color-fuchsia-teal-100: var(--fuchsia-teal-100);
  --color-fuchsia-teal-150: var(--fuchsia-teal-150);
  --color-fuchsia-teal-200: var(--fuchsia-teal-200);
  --color-fuchsia-teal-250: var(--fuchsia-teal-250);
  --color-fuchsia-teal-300: var(--fuchsia-teal-300);
  --color-fuchsia-teal-350: var(--fuchsia-teal-350);
  --color-fuchsia-teal-400: var(--fuchsia-teal-400);
  --color-fuchsia-teal-450: var(--fuchsia-teal-450);
  --color-fuchsia-teal-500: var(--fuchsia-teal-500);
  --color-fuchsia-teal-550: var(--fuchsia-teal-550);
  --color-fuchsia-teal-600: var(--fuchsia-teal-600);
  --color-fuchsia-teal-650: var(--fuchsia-teal-650);
  --color-fuchsia-teal-700: var(--fuchsia-teal-700);
  --color-fuchsia-teal-750: var(--fuchsia-teal-750);
  --color-fuchsia-teal-800: var(--fuchsia-teal-800);
  --color-fuchsia-teal-850: var(--fuchsia-teal-850);
  --color-fuchsia-teal-900: var(--fuchsia-teal-900);
  --color-fuchsia-teal-950: var(--fuchsia-teal-950);
  --color-fuchsia-teal-1000: var(--fuchsia-teal-1000);
}

:root {
  --ember-50: oklch(0.269413 0.01036 242.083865);
  --ember-100: oklch(0.280695 0.036934 253.775209);
  --ember-150: oklch(0.291519 0.065114 265.659595);
  --ember-200: oklch(0.301311 0.094461 278.30015);
  --ember-250: oklch(0.312009 0.120788 290.206075);
  --ember-300: oklch(0.322758 0.148913 302.732273);
  --ember-350: oklch(0.369931 0.162489 318.211549);
  --ember-400: oklch(0.418729 0.176089 333.932697);
  --ember-450: oklch(0.466956 0.190513 349.223418);
  --ember-500: oklch(0.513643 0.203545 4.69366);
  --ember-550: oklch(0.561955 0.217505 20.33356);
  --ember-600: oklch(0.585314 0.212514 24.790531);
  --ember-650: oklch(0.607539 0.207411 29.085222);
  --ember-700: oklch(0.628775 0.202089 33.534271);
  --ember-750: oklch(0.650881 0.19719 37.750468);
  --ember-800: oklch(0.674414 0.192429 42.148083);
  --ember-850: oklch(0.701477 0.187172 49.361077);
  --ember-900: oklch(0.726736 0.179402 55.252765);
  --ember-950: oklch(0.753502 0.17373 61.793866);
  --ember-1000: oklch(0.779125 0.169366 69.443705);
  --ember-1050: oklch(0.805038 0.167358 77.590601);
  --earthfire-50: oklch(0.361361 0.058506 66.920145);
  --earthfire-100: oklch(0.376354 0.078643 60.457792);
  --earthfire-150: oklch(0.389913 0.09828 53.546838);
  --earthfire-200: oklch(0.405209 0.117174 44.341469);
  --earthfire-250: oklch(0.418027 0.138006 37.615244);
  --earthfire-300: oklch(0.432199 0.159379 33.02244);
  --earthfire-350: oklch(0.481236 0.166424 34.74618);
  --earthfire-400: oklch(0.527869 0.172446 36.568043);
  --earthfire-450: oklch(0.576155 0.179105 38.361169);
  --earthfire-500: oklch(0.62691 0.18587 40.41205);
  --earthfire-550: oklch(0.674414 0.192429 42.148083);
  --earthfire-600: oklch(0.701477 0.187172 49.361077);
  --earthfire-650: oklch(0.726736 0.179402 55.252765);
  --earthfire-700: oklch(0.753502 0.17373 61.793866);
  --earthfire-750: oklch(0.779125 0.169366 69.443705);
  --earthfire-800: oklch(0.805038 0.167358 77.590601);
  --earthfire-850: oklch(0.829388 0.153446 80.686547);
  --earthfire-900: oklch(0.854539 0.139994 84.274241);
  --earthfire-950: oklch(0.879459 0.126376 87.177348);
  --earthfire-1000: oklch(0.904874 0.112967 90.631198);
  --earthfire-1050: oklch(0.928754 0.099044 94.038586);
  --fuchsia-heat-50: oklch(0.340576 0.146851 341.706145);
  --fuchsia-heat-100: oklch(0.39295 0.168058 341.453107);
  --fuchsia-heat-150: oklch(0.44562 0.190168 341.161978);
  --fuchsia-heat-200: oklch(0.497141 0.211145 340.960438);
  --fuchsia-heat-250: oklch(0.549558 0.232656 340.736035);
  --fuchsia-heat-300: oklch(0.601253 0.254233 340.252307);
  --fuchsia-heat-350: oklch(0.615196 0.241283 352.619879);
  --fuchsia-heat-400: oklch(0.63119 0.22952 4.913037);
  --fuchsia-heat-450: oklch(0.645314 0.217167 17.377063);
  --fuchsia-heat-500: oklch(0.659495 0.205206 29.726519);
  --fuchsia-heat-550: oklch(0.674414 0.192429 42.148083);
  --fuchsia-heat-600: oklch(0.701477 0.187172 49.361077);
  --fuchsia-heat-650: oklch(0.726736 0.179402 55.252765);
  --fuchsia-heat-700: oklch(0.753502 0.17373 61.793866);
  --fuchsia-heat-750: oklch(0.779125 0.169366 69.443705);
  --fuchsia-heat-800: oklch(0.805038 0.167358 77.590601);
  --fuchsia-heat-850: oklch(0.829388 0.153446 80.686547);
  --fuchsia-heat-900: oklch(0.854539 0.139994 84.274241);
  --fuchsia-heat-950: oklch(0.879459 0.126376 87.177348);
  --fuchsia-heat-1000: oklch(0.904874 0.112967 90.631198);
  --fuchsia-heat-1050: oklch(0.928754 0.099044 94.038586);
  --polar-glow-50: oklch(0.289999 0.117296 259.841938);
  --polar-glow-100: oklch(0.346412 0.139327 259.961746);
  --polar-glow-150: oklch(0.404605 0.161871 260.061885);
  --polar-glow-200: oklch(0.461781 0.184828 260.313682);
  --polar-glow-250: oklch(0.517315 0.207024 260.543294);
  --polar-glow-300: oklch(0.575113 0.229834 260.756335);
  --polar-glow-350: oklch(0.578705 0.191386 255.121913);
  --polar-glow-400: oklch(0.578804 0.15527 247.855287);
  --polar-glow-450: oklch(0.574245 0.124526 236.539125);
  --polar-glow-500: oklch(0.562986 0.104886 223.037098);
  --polar-glow-550: oklch(0.55658 0.080187 210.887635);
  --polar-glow-600: oklch(0.615402 0.079898 209.572467);
  --polar-glow-650: oklch(0.670375 0.079742 209.417364);
  --polar-glow-700: oklch(0.72976 0.079297 207.15741);
  --polar-glow-750: oklch(0.785871 0.079214 207.048747);
  --polar-glow-800: oklch(0.843907 0.078713 205.971232);
  --polar-glow-850: oklch(0.859948 0.069402 202.812071);
  --polar-glow-900: oklch(0.87702 0.058972 198.797615);
  --polar-glow-950: oklch(0.893654 0.050348 194.734525);
  --polar-glow-1000: oklch(0.911229 0.040839 188.845638);
  --polar-glow-1050: oklch(0.926969 0.030829 186.587966);
  --glacier-pool-50: oklch(0.322758 0.148913 302.732273);
  --glacier-pool-100: oklch(0.374656 0.163573 300.324655);
  --glacier-pool-150: oklch(0.425736 0.178167 297.580897);
  --glacier-pool-200: oklch(0.479328 0.192259 295.464688);
  --glacier-pool-250: oklch(0.529513 0.208229 292.881773);
  --glacier-pool-300: oklch(0.58173 0.221615 290.501683);
  --glacier-pool-350: oklch(0.580137 0.223519 284.586437);
  --glacier-pool-400: oklch(0.579752 0.224844 278.450141);
  --glacier-pool-450: oklch(0.577309 0.226554 272.757579);
  --glacier-pool-500: oklch(0.575983 0.227974 266.652143);
  --glacier-pool-550: oklch(0.575113 0.229834 260.756335);
  --glacier-pool-600: oklch(0.63419 0.200676 253.816025);
  --glacier-pool-650: oklch(0.6898 0.174127 245.772308);
  --glacier-pool-700: oklch(0.748412 0.146952 238.284402);
  --glacier-pool-750: oklch(0.805434 0.11993 231.546964);
  --glacier-pool-800: oklch(0.864091 0.092143 223.595164);
  --glacier-pool-850: oklch(0.877515 0.082001 224.061156);
  --glacier-pool-900: oklch(0.88877 0.072084 225.828062);
  --glacier-pool-950: oklch(0.901652 0.061983 225.291305);
  --glacier-pool-1000: oklch(0.913126 0.052239 227.828856);
  --glacier-pool-1050: oklch(0.926674 0.041663 227.890787);
  --deep-current-50: oklch(0.339119 0.053288 210.303482);
  --deep-current-100: oklch(0.381439 0.05831 210.32537);
  --deep-current-150: oklch(0.425885 0.063754 210.18179);
  --deep-current-200: oklch(0.469673 0.06943 211.381297);
  --deep-current-250: oklch(0.512064 0.074544 211.194944);
  --deep-current-300: oklch(0.55658 0.080187 210.887635);
  --deep-current-350: oklch(0.562986 0.104886 223.037098);
  --deep-current-400: oklch(0.574245 0.124526 236.539125);
  --deep-current-450: oklch(0.578804 0.15527 247.855287);
  --deep-current-500: oklch(0.578705 0.191386 255.121913);
  --deep-current-550: oklch(0.575113 0.229834 260.756335);
  --deep-current-600: oklch(0.63419 0.200676 253.816025);
  --deep-current-650: oklch(0.6898 0.174127 245.772308);
  --deep-current-700: oklch(0.748412 0.146952 238.284402);
  --deep-current-750: oklch(0.805434 0.11993 231.546964);
  --deep-current-800: oklch(0.864091 0.092143 223.595164);
  --deep-current-850: oklch(0.877515 0.082001 224.061156);
  --deep-current-900: oklch(0.88877 0.072084 225.828062);
  --deep-current-950: oklch(0.901652 0.061983 225.291305);
  --deep-current-1000: oklch(0.913126 0.052239 227.828856);
  --deep-current-1050: oklch(0.926674 0.041663 227.890787);
  --blue-red-50: oklch(0.289999 0.117296 259.841938);
  --blue-red-100: oklch(0.346412 0.139327 259.961746);
  --blue-red-150: oklch(0.404605 0.161871 260.061885);
  --blue-red-200: oklch(0.461781 0.184828 260.313682);
  --blue-red-250: oklch(0.517315 0.207024 260.543294);
  --blue-red-300: oklch(0.575113 0.229834 260.756335);
  --blue-red-350: oklch(0.659895 0.181079 260.40564);
  --blue-red-400: oklch(0.743227 0.132559 259.777551);
  --blue-red-450: oklch(0.826966 0.086548 259.302243);
  --blue-red-500: oklch(0.913886 0.041736 258.372328);
  --blue-red-550: oklch(0.911745 0.043744 19.723964);
  --blue-red-600: oklch(0.823869 0.087154 19.975422);
  --blue-red-650: oklch(0.736785 0.130954 20.143132);
  --blue-red-700: oklch(0.648386 0.174007 20.021122);
  --blue-red-750: oklch(0.561955 0.217505 20.33356);
  --blue-red-800: oklch(0.513735 0.199897 19.637869);
  --blue-red-850: oklch(0.464621 0.181494 19.233197);
  --blue-red-900: oklch(0.414123 0.162854 18.194131);
  --blue-red-950: oklch(0.366342 0.145153 17.746067);
  --blue-red-1000: oklch(0.316967 0.126887 17.133117);
  --blue-orange-50: oklch(0.289999 0.117296 259.841938);
  --blue-orange-100: oklch(0.346412 0.139327 259.961746);
  --blue-orange-150: oklch(0.404605 0.161871 260.061885);
  --blue-orange-200: oklch(0.461781 0.184828 260.313682);
  --blue-orange-250: oklch(0.517315 0.207024 260.543294);
  --blue-orange-300: oklch(0.575113 0.229834 260.756335);
  --blue-orange-350: oklch(0.659895 0.181079 260.40564);
  --blue-orange-400: oklch(0.743227 0.132559 259.777551);
  --blue-orange-450: oklch(0.826966 0.086548 259.302243);
  --blue-orange-500: oklch(0.913886 0.041736 258.372328);
  --blue-orange-550: oklch(0.933349 0.035984 43.837057);
  --blue-orange-600: oklch(0.86748 0.074912 42.286109);
  --blue-orange-650: oklch(0.804424 0.115134 42.411149);
  --blue-orange-700: oklch(0.739889 0.154446 42.097443);
  --blue-orange-750: oklch(0.674414 0.192429 42.148083);
  --blue-orange-800: oklch(0.62691 0.18587 40.41205);
  --blue-orange-850: oklch(0.576155 0.179105 38.361169);
  --blue-orange-900: oklch(0.527869 0.172446 36.568043);
  --blue-orange-950: oklch(0.481236 0.166424 34.74618);
  --blue-orange-1000: oklch(0.432199 0.159379 33.02244);
  --purple-yellow-50: oklch(0.322758 0.148913 302.732273);
  --purple-yellow-100: oklch(0.374656 0.163573 300.324655);
  --purple-yellow-150: oklch(0.425736 0.178167 297.580897);
  --purple-yellow-200: oklch(0.479328 0.192259 295.464688);
  --purple-yellow-250: oklch(0.529513 0.208229 292.881773);
  --purple-yellow-300: oklch(0.58173 0.221615 290.501683);
  --purple-yellow-350: oklch(0.664976 0.178152 290.765042);
  --purple-yellow-400: oklch(0.749505 0.132289 290.742615);
  --purple-yellow-450: oklch(0.832898 0.087771 290.173031);
  --purple-yellow-500: oklch(0.91662 0.04346 291.253558);
  --purple-yellow-550: oklch(0.961229 0.033189 77.605347);
  --purple-yellow-600: oklch(0.921681 0.066554 76.393209);
  --purple-yellow-650: oklch(0.882439 0.100828 76.994256);
  --purple-yellow-700: oklch(0.843835 0.134194 77.661362);
  --purple-yellow-750: oklch(0.805038 0.167358 77.590601);
  --purple-yellow-800: oklch(0.728842 0.15156 77.733769);
  --purple-yellow-850: oklch(0.65373 0.135805 78.088427);
  --purple-yellow-900: oklch(0.577599 0.120128 78.003109);
  --purple-yellow-950: oklch(0.502188 0.104612 78.188823);
  --purple-yellow-1000: oklch(0.427326 0.08887 78.678822);
  --fuchsia-teal-50: oklch(0.340576 0.146851 341.706145);
  --fuchsia-teal-100: oklch(0.39295 0.168058 341.453107);
  --fuchsia-teal-150: oklch(0.44562 0.190168 341.161978);
  --fuchsia-teal-200: oklch(0.497141 0.211145 340.960438);
  --fuchsia-teal-250: oklch(0.549558 0.232656 340.736035);
  --fuchsia-teal-300: oklch(0.601253 0.254233 340.252307);
  --fuchsia-teal-350: oklch(0.681377 0.203473 340.178482);
  --fuchsia-teal-400: oklch(0.760257 0.152133 340.196108);
  --fuchsia-teal-450: oklch(0.840598 0.100865 340.425517);
  --fuchsia-teal-500: oklch(0.919831 0.050647 340.40848);
  --fuchsia-teal-550: oklch(0.911541 0.016561 211.040795);
  --fuchsia-teal-600: oklch(0.822569 0.032253 211.568887);
  --fuchsia-teal-650: oklch(0.734695 0.048316 209.946656);
  --fuchsia-teal-700: oklch(0.646194 0.064372 210.475981);
  --fuchsia-teal-750: oklch(0.55658 0.080187 210.887635);
  --fuchsia-teal-800: oklch(0.512064 0.074544 211.194944);
  --fuchsia-teal-850: oklch(0.469673 0.06943 211.381297);
  --fuchsia-teal-900: oklch(0.425885 0.063754 210.18179);
  --fuchsia-teal-950: oklch(0.381439 0.05831 210.32537);
  --fuchsia-teal-1000: oklch(0.339119 0.053288 210.303482);
}
